"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    return ["Pro", "Business", "Enterprise"];
});
